import urls from '../web-sh/src/config/urls';

export default {
  ...urls,
  LANDING_URL: process.env.REACT_APP_LANDING_URL,
  LOCKER_ID_URL: process.env.REACT_APP_LOCKER_ID_URL,
  LOCKER_ENTERPRISE_URL: process.env.REACT_APP_LOCKER_ENTERPRISE_URL,
  SUPPORT_CENTER_URL: 'https://support.locker.io',
  GIVE_FEEDBACK_URL: 'https://forum.locker.io',
  REPORT_BUGS_URL: 'https://docs.google.com/forms/d/1nMLJXbgVYnSQNubIaBmA64o3eII529CNKalyEAT_c5Q/edit',
  PRIVATE_EMAIL_URL: 'https://locker.io/private-email',
  MASTER_PASSWORD: 'https://locker.io/master-password',
  MANAGE_PLANS: 'https://locker.io/vi/manage-plans?plan=pm_premium',
  DESKTOP_DOWNLOAD: 'https://locker.io/download',
  EXTENSION_DOWNLOAD: 'https://locker.io/download',
  APP_STORE_URL: 'https://apps.apple.com/app/locker-password-manager/id1586927301',
  GOOGLE_PLAY_URL: 'https://play.google.com/store/apps/details?id=com.cystack.locker&pli=1',
  CAPTERRA_URL: 'https://www.capterra.com/p/265084/Locker-Password-Manager/#reviews',
  CLUTCH_URL: 'https://clutch.co/profile/locker-password-manager#reviews',
  G2_URL: 'https://www.g2.com/products/locker-password-manager/reviews',
  CHROME_EXTENSION_URL: 'https://chrome.google.com/webstore/detail/locker-password-manager/cmajindocfndlkpkjnmjpjoilibjgmgh',
  FIREFOX_EXTENSION_URL: 'https://addons.mozilla.org/en-US/firefox/addon/locker-password-manager',
  DOC_LINKS: {
    vi: {
      ...urls.DOC_LINKS.vi,
      WHAT_IS_MASTER_PASSWORD: 'https://support.locker.io/vi/locker-general/login-unlock/log-in-to-a-cloud-account/what-is-master-password',
      TWO_FA_FOR_LOCKER_ACCOUNT: 'https://support.locker.io/vi/locker-general/security-for-locker-account/2fa-for-locker-account',
      UPGRADING_TO_FAMILY_PLAN: 'https://support.locker.io/vi/locker-password-manager/general-features/plans-and-pricing/upgrading-to-family-plan',
      UPGRADING_TO_PREMIUM_PLAN: 'https://support.locker.io/vi/locker-password-manager/general-features/plans-and-pricing/upgrading-to-premium-plan',
      SHARE_ITEMS: 'https://support.locker.io/vi/locker-password-manager/vault-management/item-management/share-items',
      SET_UP_EMERGENCY_ACCESS: 'https://support.locker.io/vi/locker-general/security-for-locker-account/set-up-emergency-access',
      DATA_BREACH_SCANNER: 'https://support.locker.io/vi/locker-password-manager/general-features/built-in-add-on-features/data-breach-scanner',
      PASSWORD_HEALTH_CHECKER: 'https://support.locker.io/vi/locker-password-manager/general-features/built-in-add-on-features/password-health-checker',
      PRIVATE_EMAIL_FOR_PREMIUM: 'https://support.locker.io/vi/locker-maily/private-email-for-premium',
      IMPORT_AND_EXPORT: 'https://support.locker.io/vi/locker-password-manager/get-started/import-and-export',
      SALE_BLACK_FRIDAY: 'https://locker.io/vi/blog/black-friday-2024-sieu-uu-dai',
      CHECK_SCAM_URL: `${process.env.REACT_APP_LANDING_URL}/vi/cong-cu-nhan-biet-lua-dao`,
    },
    en: {
      ...urls.DOC_LINKS.en,
      WHAT_IS_MASTER_PASSWORD: 'https://support.locker.io/en/locker-general/login-unlock/log-in-to-a-cloud-account/what-is-master-password',
      TWO_FA_FOR_LOCKER_ACCOUNT: 'https://support.locker.io/en/locker-general/security-for-locker-account/2fa-for-locker-account',
      UPGRADING_TO_FAMILY_PLAN: 'https://support.locker.io/en/locker-password-manager/general-features/plans-and-pricing/upgrading-to-family-plan',
      UPGRADING_TO_PREMIUM_PLAN: 'https://support.locker.io/en/locker-password-manager/general-features/plans-and-pricing/upgrading-to-premium-plan',
      SHARE_ITEMS: 'https://support.locker.io/en/locker-password-manager/vault-management/item-management/share-items',
      SET_UP_EMERGENCY_ACCESS: 'https://support.locker.io/en/locker-general/security-for-locker-account/set-up-emergency-access',
      DATA_BREACH_SCANNER: 'https://support.locker.io/en/locker-password-manager/general-features/built-in-add-on-features/data-breach-scanner',
      PASSWORD_HEALTH_CHECKER: 'https://support.locker.io/en/locker-password-manager/general-features/built-in-add-on-features/password-health-checker',
      PRIVATE_EMAIL_FOR_PREMIUM: 'https://support.locker.io/en/locker-maily/private-email-for-premium',
      IMPORT_AND_EXPORT: 'https://support.locker.io/en/locker-password-manager/get-started/import-and-export',
      SALE_BLACK_FRIDAY: 'https://locker.io/blog/black-friday-2024-save-big-secure-forever',
      CHECK_SCAM_URL: `${process.env.REACT_APP_LANDING_URL}/en/cong-cu-nhan-biet-lua-dao`,
    }
  }
};
